import React from 'react';
import Card from '../../../../components/Card/Card'
import { FormattedMessage } from 'react-intl';
import RecommmendedOffersWidget from '../RecommendedOffersWidget/RecommendedOffersWidget3';
import AllOffersWidget from '../NewOffersWidget/AllOffersWidget3';


const navItems = [<FormattedMessage id='widgets.offers.tabs.all' />,
<FormattedMessage id='widgets.offers.tabs.recommended' />,]

export default () => {

    return (
        <Card.Tabs
            className='offers-widget'
            title="widgets.offers.title"
            defaultMessage="Offers"
            navItems={navItems}
            panes={[<AllOffersWidget localStorageName='NewOffersWidget' />, <RecommmendedOffersWidget localStorageName='RecommendedOffersWidget' />]}
            activeTab={1}
            collapsing
        />
    )
}